module.exports = __webpack_public_path__ + "files/caen.c94e2233ef8173595adbf90c1b718c89.pdf";